import React, {memo} from 'react';
import PropTypes from 'prop-types';
import SelectElementCmp from '@/utils/SelectElementCmp';
import NomenclaturesTemplatesCategoryApiService from '@/modules/settings/services/NomenclaturesTemplatesCategoryApiService';

const SelectCategory = ({ value, onChange, ...props }) => {

  return (
    <SelectElementCmp
      queryKey={'categories-select'}
      service={NomenclaturesTemplatesCategoryApiService}
      customMethod={'/ms-core/api/categories/search-categories-subcategories'}
      additionalParams={{type: 'REGISTER'}}
      includeValue={''}
      value={typeof value === 'object' ? value?._id : value}
      onChange={onChange}
      sort={{ code: 1 }}
      queryConfig={{ refetchOnWindowFocus: false }}
      className="custom-select"
      {...props}
    />
  );
};

SelectCategory.propTypes = {
  value: PropTypes.string || PropTypes.object,
  onChange: PropTypes.func,
  filters: PropTypes.object
};
SelectCategory.defaultProps = {
  entity: {},
};

export default memo(SelectCategory);

const CategoryView = ({value}) => {

  return (
    <div>
      {value?.name || 'N/A'}
    </div>
  );
};

CategoryView.propTypes = {
  value: PropTypes.string
};

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Code component in a table cell
 * @param {String} text this is the value of the dataIndex of the table
 * */
export const renderCategory = (text) => {
  return (
    <CategoryView value={text}/>
  );
};
